import React from "react";
import { useFetchGetLastPeriodOfUserQuery } from "../../../store";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { REPORT, UNPAID } from "../../../dayofftypes";
import Loading from "../../../components/shared/Loading";

const PermissionRight = () => {
  const { data, isLoading } = useFetchGetLastPeriodOfUserQuery({
    refetchOnMountOrArgChange: true,
  });
  if (isLoading) return <Loading isLoading={isLoading} />;
  return (
    <Box sx={{ py: 4, width: "100%" }}>
      <h2>İzin Haklarım - Son Dönem</h2>
      <Divider />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr 1fr",
          },
          gap: 3,
          width: "100%",
          mt: 3,
        }}
      >
        {data?.data.map((item, index) => (
          <Card
            key={index}
            sx={{
              p: 2,
              borderRadius: 3,
              boxShadow: 3,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              minHeight: 180,
            }}
          >
            <Typography
              variant="h6"
              component="div"
              sx={{ fontWeight: 600, mb: 2, textAlign: "center" }}
            >
              {item.dayoffTypeName}
            </Typography>
            <Divider sx={{ width: "100%", mb: 2 }} />
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 4,
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box sx={{ textAlign: "center" }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Toplam İzin Hakkı
                </Typography>
                <Divider />
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    background: "#8B1A1A",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 24,
                    fontWeight: 700,
                    mx: "auto",
                    mt: 1,
                  }}
                >
                  {item.dayoffTypeId === REPORT || item.dayoffTypeId === UNPAID
                    ? "∞"
                    : item.dayoffRightCount}
                </Box>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Kullanılan İzin
                </Typography>
                <Divider />
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    background: "#eb5df0ff",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 24,
                    fontWeight: 700,
                    mx: "auto",
                    mt: 1,
                  }}
                >
                  {item.dayoffUsedCount}
                </Box>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <Typography variant="subtitle2" color="text.secondary">
                  Kalan İzin
                </Typography>
                <Divider />
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    background: "#43a047",
                    color: "#fff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 24,
                    fontWeight: 700,
                    mx: "auto",
                    mt: 1,
                  }}
                >
                  {item.dayoffTypeId === REPORT || item.dayoffTypeId === UNPAID
                    ? "∞"
                    : item.usableDayoffCount}
                </Box>
              </Box>
            </Box>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default PermissionRight;
